module.exports = __webpack_public_path__ + "img/basic.67857f37.png";